<template>
  <div class="page-container">
    <el-card shadow="none">
      <span class="span-lable">话机编号：</span>
      <el-input v-model.trim="extenNumber" placeholder="请输入话机编号" class="input-width" size="small"></el-input>
      <span class="span-lable ml-20">话机类型：</span>
      <el-select v-model="type" placeholder="请选择话机类型" size="small" class="input-width">
        <el-option v-for="(item,index) in typeList" :key="index" :label="item.name" :value="item.value" />
      </el-select>
      <span class="span-lable ml-20">话机区号：</span>
      <el-input v-model.trim="areaCode" placeholder="请输入话机区号" class="input-width" size="small"></el-input>
      <el-button type="primary" class="ml-20" size="small" @click="getExtens">查询</el-button>
      <el-button size="small" @click="clickReset">重置</el-button>
    </el-card>

    <div class="div-table mt-10">
      <p class="p-title mt-10 mb-20">话机管理列表
        <span class="fr">
          <el-button size="mini" type="primary" @click="clickAdd">新增话机</el-button>
        </span>
      </p>
      <el-table v-loading="loading" ref="multipleTable" :data="tableData" tooltip-effect="dark" :header-cell-style="{background:'#F2F4F7',fontWeight: '400',color:'#303133'}">
        <el-table-column label="话机编号">
          <template slot-scope="scope">{{ scope.row.extenNumber }}</template>
        </el-table-column>
        <el-table-column prop="areaCode" label="话机区号">
        </el-table-column>
        <el-table-column prop="type" label="话机类型">
          <template slot-scope="scope">{{ scope.row.type == 1 ? '分机' : '软电话' }}</template>
        </el-table-column>
        <el-table-column label="话机密码">
          <template slot-scope="scope">{{ scope.row.password }}</template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template #default="scope">
            <play-status v-if="scope.row.bindStatus=='已绑定'" type="success">已绑定</play-status>
            <play-status v-else type="error">未绑定</play-status>
          </template>
        </el-table-column>
        <el-table-column prop="accountName" label="使用员工" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="userCnoNo" label="绑定座席" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" style="color: #374FB8;" @click="clickEdit(scope.row)" v-if="scope.row.bindStatus !== '已绑定'">编辑</el-button>
            <el-button type="text" style="color: #999999;" @click="deleteExten(scope.row)" v-if="scope.row.bindStatus !== '已绑定'">删除</el-button>
            <span v-if="scope.row.bindStatus == '已绑定'" style="display: inline-block;padding: 8px 0px;">--</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination :pageNum="pageNum" :pageSize="pageSize" :total="total" @sizeChange="handleSizeChange" @currentChange="handleCurrentChange" style="margin-top:80px;"></pagination>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="640px" :close-on-click-modal="false">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
        <el-form-item label="话机编号：" prop="extenNumber" :class="dialogTitle !== '编辑'?'edit-input':''">
          <span v-if="dialogTitle !== '编辑'" style="display: inline-block;width: 40px;">{{ accountCallCode }}</span>
          <el-input v-model="ruleForm.extenNumber" :disabled="dialogTitle == '编辑'" @input="ruleForm.extenNumber=ruleForm.extenNumber.replace(/[^\d]/g,'')" size="small" placeholder="请输入话机编号"></el-input>
        </el-form-item>
        <el-form-item label="话机密码：" prop="password">
          <el-input v-model="ruleForm.password" size="small" @input="ruleForm.password=ruleForm.password.replace(/[^\d]/g,'')" placeholder="请输入话机密码"></el-input>
        </el-form-item>
        <el-form-item label="区号：" prop="areaCode">
          <el-input v-model.trim="ruleForm.areaCode" @input="ruleForm.areaCode=ruleForm.areaCode.replace(/[^\d]/g,'')" size="small" placeholder="请输入区号"></el-input>
        </el-form-item>
        <el-form-item label="话机类型：" prop="type">
          <el-select v-model="ruleForm.type" size="small" placeholder="请选择话机类型" style="width: 100%;" @change="changeType">
            <el-option v-for="(item,index) in typeList" :key="index" :label="item.name" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="语音编码：" prop="allow">
          <el-select v-model="ruleForm.allow" size="small" placeholder="请选择语音编码" style="width: 100%;">
            <el-option v-for="(item,index) in codeList" :key="index" :label="item.name" :value="item.value" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="clickSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pagination from '@/components/pagination'
import { getExtens, createExten, updateExten, deleteExten, querySupplierUserCallCode } from '../api'
// import { mapState } from 'vuex'
import PlayStatus from '../component/PlayStatus'

export default {
  components: { PlayStatus, pagination },
  data () {
    var validateAreaCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入话机区号'))
      } else {
        if (value[0] != 0) {
          callback(new Error('请输入以0开头的话机区号'))
        } else {
          callback()
        }
      }
    }
    return {
      accountCallCode: '',
      rules: {
        extenNumber: [
          { required: true, message: '请输入话机编号', trigger: 'blur' },
          { min: 1, max: 5, message: '建议1-5位数字', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入话机密码', trigger: 'blur' },
          { min: 3, max: 6, message: '建议3-6位数字', trigger: 'blur' }
        ],
        areaCode: [
          { required: true, validator: validateAreaCode, trigger: 'blur' },
          { min: 3, max: 4, message: '建议3-4位数字', trigger: 'blur' }
        ],
        type: [{ required: true, message: '请选择话机类型', trigger: 'change' }],
        allow: [{ required: true, message: '请选择语音编码', trigger: 'change' }]
      },
      ruleForm: {
        extenNumber: '',
        password: '',
        areaCode: '',
        type: '',
        allow: ''
      },
      codeList: [
        { value: '1', name: 'g729' },
        { value: '2', name: 'g729,alaw,ulaw' },
        { value: '3', name: 'alaw,ulaw,g729' },
        { value: '4', name: 'myopus,alaw,ulaw,g729' }
        // { value: '5', name: 'alaw,ulaw' },
        // { value: '6', name: 'myopus,alaw,ulaw' }
      ],
      extenNumber: '', // 话机编号
      areaCode: '', // 话机区号
      type: '',
      typeList: [{ value: '1', name: '分机' }, { value: '2', name: '软电话' }],
      dialogVisible: false,
      dialogTitle: '添加',
      tableData: [],
      // 分页
      pageNum: 1,
      pageSize: 20,
      total: 0,
      loading: false
    }
  },
  computed: {
    // ...mapState({ seatsInfo: state => state.user.seatsInfo })
  },
  mounted () {
    this.getExtens()
    this.$bus.$on('refresh', (val) => {
      this.getExtens()
    })
  },
  methods: {
    changeType () {
      this.ruleForm.allow = ''
      if (this.ruleForm.type == '1') {
        this.codeList = [
          { value: '1', name: 'g729' },
          { value: '2', name: 'g729,alaw,ulaw' },
          { value: '3', name: 'alaw,ulaw,g729' },
          { value: '4', name: 'myopus,alaw,ulaw,g729' }
        ]
      } else {
        this.codeList = [
          { value: '5', name: 'alaw,ulaw' },
          { value: '6', name: 'myopus,alaw,ulaw' }
        ]
      }
    },
    deleteExten (row) {
      this.$confirm('请确认是否删除话机', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteExten({ id: row.id }).then(res => {
          this.$message.success('删除成功')
          this.getExtens()
        })
      }).catch(() => {})
    },
    clickSubmit () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.dialogTitle === '添加') {
            createExten(this.ruleForm).then(res => {
              this.$message.success('添加成功')
              this.dialogVisible = false
              this.getExtens()
            })
          } else {
            updateExten(this.ruleForm).then(res => {
              this.dialogVisible = false
              this.$message.success('编辑成功')
              this.getExtens()
            })
          }
        } else {
          return false
        }
      })
    },
    clickEdit (row) {
      this.rules.extenNumber = [
        { required: true, message: '请输入话机编号', trigger: 'blur' }
      ]
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
      this.dialogVisible = true
      this.dialogTitle = '编辑'
      this.ruleForm = JSON.parse(JSON.stringify(row))
      if (this.ruleForm.type == '1') {
        this.codeList = [
          { value: '1', name: 'g729' },
          { value: '2', name: 'g729,alaw,ulaw' },
          { value: '3', name: 'alaw,ulaw,g729' },
          { value: '4', name: 'myopus,alaw,ulaw,g729' }
        ]
      } else {
        this.codeList = [
          { value: '5', name: 'alaw,ulaw' },
          { value: '6', name: 'myopus,alaw,ulaw' }
        ]
      }
    },
    clickAdd () {
      querySupplierUserCallCode().then(res => {
        this.accountCallCode = res.data.accountCallCode
      })
      this.rules.extenNumber = [
        { required: true, message: '请输入话机编号', trigger: 'blur' },
        { min: 1, max: 5, message: '建议1-5位数字', trigger: 'blur' }
      ]
      this.dialogVisible = true
      this.dialogTitle = '添加'
      this.codeList = [
        { value: '1', name: 'g729' },
        { value: '2', name: 'g729,alaw,ulaw' },
        { value: '3', name: 'alaw,ulaw,g729' },
        { value: '4', name: 'myopus,alaw,ulaw,g729' }
      ]
      this.$nextTick(() => {
        this.ruleForm = {
          extenNumber: '',
          password: '',
          areaCode: '',
          type: '',
          allow: ''
        }
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.resetFields()
        }
      })
    },
    clickReset () {
      this.pageNum = 1
      this.pageSize = 20
      this.extenNumber = ''
      this.areaCode = ''
      this.type = ''
      this.getExtens()
    },
    getExtens () {
      var data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        extenNumber: this.extenNumber,
        areaCode: this.areaCode,
        type: this.type
      }
      getExtens(data).then(res => {
        this.tableData = this.Global.transformEmptyObject(res.data.list)
        this.total = Number(res.data.total)
        this.loading = false
      }).catch(_ => { this.loading = false })
    },
    // 分页的
    handleSizeChange (val) {
      this.pageNum = 1
      this.pageSize = val
      this.getExtens()
    },
    handleCurrentChange (i) {
      this.pageNum = i
      this.getExtens()
    }
  },
  beforeDestroy () {
    this.$bus.$off('refresh')
  }
}
</script>

<style lang="scss" scoped>
.edit-input{
  .el-input{
    width: calc(100% - 50px);
    margin-left: 10px;
  }
  /deep/ .el-form-item__error{
    left: 50px;
  }
}
/deep/ .el-dialog__footer {
  .el-button {
    width: 100px;
    height: 36px;
    line-height: 36px;
    padding: 0;
  }
}
/deep/ .el-dialog__body {
  padding: 30px 50px;
  border-top: 1px #e5e5e5 solid;
  border-bottom: 1px #e5e5e5 solid;
}
.el-card {
  border: 0;
}
/deep/.el-button--small {
  font-size: 14px;
  padding: 8px 15px;
}
.div-table {
  padding: 24px;
  background: #fff;
  border-radius: 3px;
  box-shadow: 0px 0px 10px 0px rgba(37, 53, 138, 0.1);
  .el-button--primary {
    // background: #374fb8;
    // border-color: #374fb8;
    padding: 8.5px 28px;
    margin-left: 24px;
    position: relative !important;
    top: -6px !important;
  }
  .p-title {
    color: #333;
    font-weight: 600;
    border-left: 2px solid #374fb8;
    padding-left: 5px;
    .el-button {
      position: relative;
      top: -5px;
    }
  }
}
.span-lable {
  display: inline-block;
  text-align: right;
  width: 60px;
  color: #666;
  font-size: 12px;
  margin-right: 8px;
}
.input-width {
  width: 160px;
}
</style>
